<template>
  <div
    class="sendmsg_popup"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <el-form :model="ruleform" :rules="rules" ref="ruleform">
      <el-form-item label="日报" prop="Content">
        <el-input
          v-model="ruleform.Content"
          type="textarea"
          placeholder="请输入要发送的内容"
          :autosize="{ minRows: 6, maxRows: 6 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="接收人" prop="PhoneList">
        <div
          :style="{ margin: '2px 0px' }"
          v-for="(item, index) in ruleform.PhoneList"
          :key="index"
        >
          <el-input :style="inlineItemStyle50" v-model="item.Phone"></el-input>
          <!-- <el-button
            :style="{ 'background-color': 'transparent' }"
            @click="addContact()"
            >添加</el-button
          > -->
          <!-- <el-button
            :style="{
              color: '#f04a4c',
              'background-color': 'transparent',
              'border-color': '#f04a4c',
            }"
            @click="removeContact(index)"
            >删除</el-button
          > -->
        </div>
      </el-form-item>
    </el-form>

    <el-button class="search_btn" @click="sendMsg">发 送</el-button>
    <el-button class="cancel_btn" @click="close">取 消</el-button>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {

      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem",
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem",
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem",
      },
      loading: false,
      loadingText: "发送中...",
      ruleform: {
        Content: "天山天池景区：2020年11月12日当日人次1918人（其中：天池主景区678人，水磨沟81人，山坡村121人，马牙山景观135人，五江812人，天池游船91人），较2019年同期1466人同比增长31%，旅游经济收入96万元较2019年同期205万元同比下降53% 。",
        PhoneList: [{ Phone: "" }],
      },
      rules: {
        Content: [
          { required: true, message: "请填写日报内容", trigger: "blur" },
        ],
        PhoneList: [
          {
            type: "array",
            required: true,
            validator: this.validphone,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value || value.length == 0) {
        callback(new Error("请输入电话号码"));
      } else if (!this.validphonelist(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validphonelist(arr) {
      var result = arr.every(function (item) {
        return ZJApp.ZJUtils.isRightMobileNum(item.Phone);
      });
      return result;
    },
    close() {
      this.$emit("handle_close");
    },
    sendMsg() {
      this.$refs["ruleform"].validate().then((valid) => {
        if (valid) {
          this.loading = true;
          new MyApis.SendSmsApi()
            .SendSms({
              // Id: 1,
              Id: ZJApp.ZJUtils.uuid(),
              PhoneNo: this.ruleform.PhoneList[0].Phone,
              Content: this.ruleform.Content,
              Charset: "GBK",
              Creater: ZJApp.ZJUser.current.UserName,
              CreateTime: new Date(),
              Modifier: ZJApp.ZJUser.current.UserName,
              ModifyTime: new Date(),
              SendTime: new Date(),
              Extends2: this.ruleform.PhoneList[0].Phone,
            })
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "消息发送成功!",
                });
                this.$emit("handle_close");
              } else {
                this.$message({
                  type: "error",
                  message: "消息发送失败!",
                });
                this.$emit("handle_close");
              }
              this.loading = false;
            })
            .catch((e) => {
              console.error(e);
              this.$message(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-dialog{
  width:70rem !important;
}

.cancel_btn {
  float:right !important;
}
</style>